import { render, staticRenderFns } from "./UserPosts.vue?vue&type=template&id=518ea2aa&scoped=true&"
import script from "./UserPosts.vue?vue&type=script&lang=js&"
export * from "./UserPosts.vue?vue&type=script&lang=js&"
import style0 from "./UserPosts.vue?vue&type=style&index=0&id=518ea2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518ea2aa",
  null
  
)

export default component.exports